import { render, staticRenderFns } from "./reg_email_question.vue?vue&type=template&id=44ea6456&"
import script from "./reg_email_question.vue?vue&type=script&lang=js&"
export * from "./reg_email_question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports